import publicMethod from '@/utils/publicMethod';
import { message } from 'antd';
import { useEffect, useState, useRef, MutableRefObject } from 'react';
import loginApi from '@/api/login';
import NodeRSA from 'node-rsa';
import markIcon from '@/assets/images/address-marker.png';
const MapCom = (props: {
    workAddress: string;
    mapWidth: number;
    mapHeight: number;
    save?: any;
    location: { lat: number | null; lon: number | null };
    editTaskId: string;
}) => {
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [location, setLocation] = useState({ lat: 0, lon: 0 });
    const [currentLocation, setcurrentLocation] = useState({ lat: -33.87076, lng: 151.20964 });
    const inMap: any = useRef(null);
    const initMap = (lat: number, lng: number) => {
        if (!lat || !lng || !window.google) return;
        console.log('initMap chen', lat, lng);
        const map = new window.google.maps.Map(document.getElementById('map'), {
            center: { lat, lng },
            zoom: 15,
            language: 'en',
            zoomControl: true,
            clickableIcons: false,
            zoomControlOptions: {
                style: {
                    width: '30px',
                    height: '50px',
                },
            },
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [{ color: '#BEF2A9' }],
            },
        });
        inMap.current = map;
        if (props.mapWidth === 560) {
            addMarker(lat, lng, map);
        } else {
            addOverlayView(lat, lng, map);
        }
    };
    const autoInput: MutableRefObject<any> = useRef(null);
    const getMapKey = async () => {
        try {
            const tres = await loginApi.getPublickey();
            const res = await loginApi.getKeyInfo();
            const publicKeyStr = '-----BEGIN PUBLIC KEY-----' + tres.data.publicKey + '-----END PUBLIC KEY-----';
            const key = new NodeRSA(publicKeyStr);
            key.setOptions({ encryptionScheme: 'pkcs1' });
            const decryptPublic = key.decryptPublic(res.data, 'utf8');
            setMapKey(JSON.parse(decryptPublic).googleMapsKey);
        } catch (error: any) {
            message.error(error);
        }
    };
    const setMapKey = (key: string) => {
        if (!key) return;
        const head = document.head;
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&callback=initMap&language=en`;
        script.onload = function () {
            console.log('Script loaded successfully');
            if (props.location.lat !== null && props.location.lon !== null) {
                console.log('isFirstRun');
                initMap(Number(props.location.lat), Number(props.location.lon));
            } else {
                console.log('getCurrentPosition');
                initMap(-33.86491176500064, 151.19971727005225);
            }
        };
        script.onerror = function () {
            console.error('Script loading failed');
        };
        head && head.appendChild(script);
    };
    useEffect(() => {
        getMapKey();
    }, []);
    useEffect(() => {
        if (props.location.lat !== null && props.location.lon !== null) {
            if (props.mapWidth === 560) {
                inMap && inMap.current && addMarker(props.location.lat, props.location.lon, true);
            } else {
                inMap && inMap.current && addOverlayView(props.location.lat, props.location.lon, true);
            }
        }
    }, [props.location]);
    const overlayExample: MutableRefObject<any> = useRef(null);
    const overlayRef: MutableRefObject<any> = useRef(null);
    const addOverlayView = (lat, lng, draw: boolean) => {
        inMap.current.setCenter({ lat, lng });
        const overlay = new window.google.maps.OverlayView();
        overlay.onAdd = function () {
            const div = document.createElement('div');
            div.className = 'match-range';
            div.style.position = 'absolute';
            // div.innerHTML = '1 KMS';
            overlayRef.current = div;
            const panes = this.getPanes();
            panes.overlayLayer.appendChild(div);
        };

        overlay.draw = function () {
            const overlayProjection = this.getProjection();
            const positionPixel = overlayProjection.fromLatLngToDivPixel({ lat, lng });
            const div = overlayRef.current;
            div.style.left = positionPixel.x - div.offsetWidth / 2 + 'px';
            div.style.top = positionPixel.y - div.offsetHeight / 2 + 'px';
        };

        overlay.onRemove = function () {
            overlayRef.current.parentNode.removeChild(overlayRef.current);
        };
        if (draw) {
            overlay.setMap(inMap.current);
        }

        overlayExample.current = overlay;
        // const listener = map.addListener('zoom_changed', () => {
        //     overlay.draw();
        // });
        // return () => {
        //     overlay.setMap(null);
        // };
    };
    const addMarker = (lat: number, lng: number, map: any) => {
        const position = { lat, lng };
        const customIcon = {
            url: markIcon,
            scaledSize: new window.google.maps.Size(44, 44),
        };
        new window.google.maps.Marker({
            position: new window.google.maps.LatLng(position),
            map,
            icon: customIcon,
            optimized: false,
        });
    };
    return <div id="map" style={{ width: props.mapWidth, height: props.mapHeight }}></div>;
};
export default MapCom;
